'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';

var Intro = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('艺品网介绍')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Intro, _Component);

  function Intro() {
    (0, _classCallCheck3.default)(this, Intro);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Intro).call(this));

    _this.state = {
      headerActiveIndex: 0
    };
    return _this;
  }

  (0, _createClass3.default)(Intro, [{
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = {
        bg1: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_1.jpg' }],
        bg2: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_2.jpg' }],
        bg3: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_3.jpg' }],
        bg4: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_4.jpg' }],
        bg5: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_5.jpg' }],
        bg6: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_6.jpg' }],
        bg7: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_7.jpg' }],
        bg8: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_8.jpg' }],
        bg9: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_9.jpg' }],
        bg10: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_10.jpg' }],
        bg11: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_11.jpg' }],
        bg12: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_12.jpg' }],
        bg13: [{ img: 'http://tupian.goeasy.cn:9999/yipinwang/third/three_banner_bg_13.jpg' }]
      };
      var styles = require('./Intro.scss');
      var headerActiveIndex = this.state.headerActiveIndex;

      var options = {
        sectionClassName: 'section',
        anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11', 'page12', 'page13'],
        scrollBar: false,
        activeClass: styles.active,
        navigation: false,
        verticalAlign: false,
        sectionPaddingTop: '0',
        sectionPaddingLeft: '0',
        sectionPaddingRight: '0',
        sectionPaddingBottom: '0'
      };
      var resultDiv = _react2.default.createElement(
        'div',
        { className: styles.component },
        headerActiveIndex === 0 ? _react2.default.createElement(
          'a',
          { href: '#page2', className: styles.nextIcon },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
        ) : '',
        _react2.default.createElement(_components.FullPageHeader, null),
        _react2.default.createElement(
          _components.FullPageSectionsContainer,
          (0, _extends3.default)({ activeChange: this.activeChange.bind(this),
            className: 'container' }, options),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '0', className: styles.goeasySection },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(_Header2.default, null)
            ),
            _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true, images: data.bg1 })
            )
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '1', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg2 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '2', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg3 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '3', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg4 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '4', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg5 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '5', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg6 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '6', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg7 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '7', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg8 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '8', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg9 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '9', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg10 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '10', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg11 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '11', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg12 })
          ),
          _react2.default.createElement(
            _components.FullPageSection,
            { key: '12', className: styles.goeasySection },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { page: 'Intro', images: data.bg13 })
          )
        )
      );
      return resultDiv;
    }
  }]);
  return Intro;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Intro;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Intro/Intro.js
 ** module id = 1489
 ** module chunks = 0
 **/